import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SidebarContainer } from "../../../components";
import { Card } from "../../../shared";
import { DocumentTextIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { buildHelpFeaturesPath } from "@/features/help-hub/help-links";

const BestPractices = () => {
  const navigate = useNavigate();
  const headerRef = useRef();
  const [headerContext, setHeaderContext] = useState();

  useEffect(() => {
    setHeaderContext(headerRef.current);
  }, [headerRef.current]);

  const renderTabHeader = (headerProps) => {
    return <div ref={headerRef}></div>;
  };

  const practiceSections = [
    {
      title: "Job Management",
      description: "Best practices for managing jobs efficiently",
      link: buildHelpFeaturesPath("jobs"),
      subsections: [
        {
          title: "Job Creation Workflow",
          link: buildHelpFeaturesPath("jobs"),
        },
        { title: "Status Updates", link: "/jobs" },
        {
          title: "Communication",
          link: buildHelpFeaturesPath("feedback"),
        },
      ],
    },
    {
      title: "Customer Relations",
      description: "Tips for maintaining strong customer relationships",
      link: buildHelpFeaturesPath("clients"),
      subsections: [
        {
          title: "Customer Onboarding",
          link: buildHelpFeaturesPath("clients"),
        },
        {
          title: "Service Quality",
          link: "/clients",
        },
        {
          title: "Feedback Management",
          link: "/feedback/create",
        },
      ],
    },
    {
      title: "Billing and Payout Control",
      description: "Keep revenue and payout workflows consistent",
      link: buildHelpFeaturesPath("invoices"),
      subsections: [
        { title: "Invoice best practices", link: buildHelpFeaturesPath("invoices") },
        {
          title: "Payout best practices",
          link: buildHelpFeaturesPath("payouts"),
        },
        { title: "Open invoices app", link: "/invoices" },
      ],
    },
    {
      title: "Operations Configuration",
      description: "Configure trucking and settings for repeatable execution",
      link: buildHelpFeaturesPath("settings-general"),
      subsections: [
        { title: "Manifests workflow", link: buildHelpFeaturesPath("manifests") },
        {
          title: "Settings workflow",
          link: buildHelpFeaturesPath("settings-general"),
        },
        {
          title: "Dispatch settings",
          link: buildHelpFeaturesPath("settings-dispatch"),
        },
      ],
    },
  ];

  const handleSectionClick = (link) => {
    navigate(link);
  };

  return (
    <SidebarContainer hideSidebar header={renderTabHeader}>
      {({ parentHeight, parentWidth }) => {
        const offsetTop = headerContext?.offsetTop || 0;
        const offsetHeight = headerContext?.offsetHeight || 0;

        return (
          <div className="h-full overflow-y-auto w-full">
            <div className="w-full px-4 sm:px-6 lg:px-8 py-12">
              <div className="max-w-7xl mx-auto">
                <h1 className="text-4xl font-bold text-gray-900 mb-6">
                  Best Practices
                </h1>
                <p className="text-xl text-gray-600 mb-12">
                  Tips and recommendations for getting the most out of Attune
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {practiceSections.map((section) => (
                    <Card
                      key={section.title}
                      className="p-6 hover:shadow-lg transition-shadow duration-200"
                    >
                      <div className="flex flex-col h-full">
                        <div className="flex items-center mb-4">
                          <DocumentTextIcon className="h-6 w-6 text-primary-600 mr-2" />
                          <h2 className="text-xl font-semibold text-gray-900">
                            {section.title}
                          </h2>
                        </div>
                        <p className="text-gray-600 mb-4">
                          {section.description}
                        </p>
                        <div className="mt-4 space-y-2">
                          {section.subsections.map((subsection) => (
                            <div
                              key={subsection.title}
                              className="flex items-center text-primary-600 hover:text-primary-800 cursor-pointer"
                              onClick={() =>
                                handleSectionClick(subsection.link)
                              }
                            >
                              <ArrowRightIcon className="h-4 w-4 mr-2" />
                              <span>{subsection.title}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </SidebarContainer>
  );
};

export default BestPractices;
